const createQuery = () => `
  ... on ArticleLayoutStoryCta {
    id
    magazine {
      slug
      images {
        cover_321x446_150 {
          url
          caption
          link
        }
      }
    }
  }
`

export default createQuery
